function ButtonATCDisabled({ text }) {
  return (
    <button type="button" title={text} className="relative w-full button-primary" disabled>
      {text}
    </button>
  )
}

export default ButtonATCDisabled
